import ClassNames from "classnames";
import { FunctionComponent, ReactNode, RefObject } from "react";
import styles from "../stylesheets/components/editor-ui-container.module.css";

interface Props {
  className?: string;
  ref?: RefObject<HTMLDivElement | null>;
  children: ReactNode;
}

const EditorUIContainer: FunctionComponent<Props> = ({
  className,
  ref,
  children,
}) => {
  return (
    <div ref={ref} className={ClassNames(styles.EditorUIContainer, className)}>
      {children}
    </div>
  );
};

export default EditorUIContainer;
